import { Box, Link, Stack, SxProps, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { ContextActionItemVersionDto } from "src/http";
import { Links } from "../../constants";
import { AnimatedErrorIcon } from "../AnimatedErrorIcon";
import { CardTooltip } from "../CardTooltip";

interface IProps {
  previousDescription: string;
  updatedContext: ContextActionItemVersionDto;
  footer?: React.ReactNode;
  sx?: SxProps;
}

const ContextSyncAlert = (props: IProps) => {
  const theme = useTheme();

  return (
    <>
      <CardTooltip
        title={props.updatedContext.isDeleted ? "Context Item Deleted" : "Context Item Updated"}
        content={
          <Stack spacing={1}>
            <Stack spacing={0.25} sx={{ minWidth: 0, width: "100%" }}>
              <Stack
                direction={{ xs: "column", lg: "row" }}
                spacing={0.25}
                sx={{
                  minWidth: 0,
                  alignItems: "baseline",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <Link variant="body2" href={Links.User(props.updatedContext.modifiedByUser.userId)} underline="none">
                  {props.updatedContext.modifiedByUser.displayName}
                </Link>
                <Typography variant="caption" sx={{ minWidth: 0 }} noWrap>
                  {DateTime.fromISO(props.updatedContext.modifiedDateTimeUtc, { zone: "utc" })
                    .toLocal()
                    .toLocaleString(DateTime.DATETIME_FULL)}
                </Typography>
              </Stack>

              <Box>
                {props.updatedContext.isDeleted ? (
                  <Typography>
                    {`Action item `}
                    <Box component="span" sx={{
                      fontWeight: 700
                    }}>
                      {props.updatedContext.description}
                    </Box>
                    {` has been removed.`}
                  </Typography>
                ) : (
                  <Typography>
                    {`Action item has been updated to `}
                    <Box component="span" sx={{
                      fontWeight: 700
                    }}>
                      {props.updatedContext.description}
                    </Box>
                    {`.`}
                  </Typography>
                )}
              </Box>
            </Stack>
            <Stack spacing={1}>
              <Typography>
                {props.updatedContext.isDeleted
                  ? "Remove the context from this action item to ensure alignment."
                  : "Update the context to ensure alignment."}
              </Typography>
            </Stack>
          </Stack>
        }
      >
        <AnimatedErrorIcon
          sx={{
            ...props.sx,
            color: props.updatedContext.isDeleted ? theme.palette.error.main : theme.palette.secondary.main,
          }}
        />
      </CardTooltip>
    </>
  );
};

export { ContextSyncAlert };
